module.exports = __webpack_public_path__ + "static/media/slack.ea10358f.jpeg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/slack.jpeg
 ** module id = 514
 ** module chunks = 0
 **/